import Input from 'components/Input'
import Loader from 'components/Loader'
import Message from 'components/UI/Message'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import {
  onCartCheckoutConversion,
  onProductAddToCartEvent,
} from 'services/conversionevents'
import OrdersService from 'services/OrdersService'
import useAuth from 'store/AuthContext'
import useCart from 'store/CartProvider'
import useOrders from 'store/OrdersProvider'
import useProduct from 'store/SingleProductProvider'
import { LabelWithInput } from 'components/Widgets/Landing/Product/Product.style'
import ChooseBank from 'pages/PurchasePage/ChooseBank'
import Button from 'components/Button'
import OrderSuccessConfirmationModal from 'components/Order/OrderSuccessConfirmationModal'
import { appendTrackingParamsToFormData } from 'consts'

const ProductPurchaseWithCard = props => {
  const { product } = useProduct()
  const { canSendOrder, payMethod, products, addToCart } = useCart()
  const { user, userAuthenticated } = useAuth()
  const history = useHistory()
  const [success, setSuccess] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState({})
  const [requestError, setRequestError] = useState(false)
  const { setSuccessMessage } = useOrders()

  const orderFormSubmitted = e => {
    e.preventDefault()
    let formData = new FormData(e.target)
    formData.append('pay_method', payMethod)
    formData.append('from_site', 1)
    formData = appendTrackingParamsToFormData(formData)

    setLoading(true)
    setRequestError(false)
    onProductAddToCartEvent(product, {
      payMethod: payMethod,
    })
    OrdersService.placeLandingOrder(formData)
      .then(data => {
        setSuccess(true)
        setLoading(false)
        setSuccessMessage(
          'თქვენი მოთხოვნა წარმატებით დაფიქსირდა. ოპერატორი მალე დაგიკავიშრდებათ და გაგაცნობთ დეტალურ ინფორმაციას.'
        )
        onCartCheckoutConversion(products, {
          total: product.price,
          payMethod: payMethod,
          order_id: data.order_id,
        })
        if (data.next_step === 'profile') {
          history.push('/account/orders')
        } else if (data.next_step === 'confirm_number') {
          setResponse(data)
          setConfirmModal(true)
        }
        /* eslint-disable-next-line */
      })
      .catch(err => {
        console.log(err)
        setRequestError(true)
        setLoading(false)
      })
  }

  const buyItemWithCardShortcut = e => {
    e.preventDefault()
    e.stopPropagation()
    const formData = new FormData(e.target)
    formData.append('pay_method', 'card')
    formData.append('from_site', 1)
    formData.append('only_number', 1)

    setLoading(true)
    setRequestError(false)

    addToCart(product.sku, {}, true, false)
      .then(() => {
        onProductAddToCartEvent(product, {
          payMethod: payMethod,
        })
      })
      .then(() => {
        OrdersService.placeCartOrder(formData)
          .then(data => {
            setLoading(false)
            setSuccessMessage(
              'თქვენი მოთხოვნა წარმატებით დაფიქსირდა. ოპერატორი მალე დაგიკავიშრდებათ და გაგაცნობთ დეტალურ ინფორმაციას.'
            )

            if (data.next_step === 'redirect_to_pay' && data.redirect_url) {
              document.location.replace(data.redirect_url)
            } else if (data.next_step === 'confirm_number') {
              /**
               * Skipped confirm number, uncomment below code to enable it again and enable confirmation modal in jsx
               */
              setTimeout(() => {
                window.location.href = data.redirect_url
              }, 300)
              // setResponse(data)
              // setConfirmModal(true)
            }
          })
          .catch(() => {
            setRequestError(true)
            setLoading(false)
          })
      })
  }

  const onOrderConfirm = () => {
    console.log(response)
    console.log(confirmModal)
  }

  return (
    <div>
      <div style={{ padding: 16 }}>
        <OrderSuccessConfirmationModal
          onNumberConfirm={onOrderConfirm}
          show={confirmModal}
          response={response}
        />
        {loading ? (
          <div className="flex py-4">
            <Loader notFull visible={true} type="ThreeDots" />
          </div>
        ) : (
          <form onSubmit={buyItemWithCardShortcut}>
            <input type="hidden" name="product_id" value={product.id} />
            <input
              type="hidden"
              name="landing_signature"
              value={product.landing.signature}
            />
            <LabelWithInput
              style={{ gridRowGap: '8px', marginBottom: 10 }}
              className="phone-label"
            >
              <span>ტელეფონის ნომერი:</span>
              <Input
                style={{ borderRadius: '10px', borderColor: 'green' }}
                defaultValue={user.phone}
                name="number"
                component="custom"
                type="number"
                placeholder="5XX XXX XXX"
              />
            </LabelWithInput>
            <Button color="orange" type="submit">
              ყიდვა
            </Button>
          </form>
        )}
        <ChooseBank />
      </div>
      <div style={{ padding: 25, paddingTop: 0 }}>
        <Message
          show={requestError}
          type="error"
          message="შეცდომა განაცხადის დაფიქსირებისას, გთხოვთ შეავსეთ ყველა ველი სწორად"
        />
      </div>
    </div>
  )
}

export default ProductPurchaseWithCard
